var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/assets/images/logo/logo.png?vue&type=custom&index=0&blockType=img&issuerPath=%2Fbuilds%2Foffice-automation%2Ffrontend%2Fsrc%2F%40core%2Flayouts%2Fcomponents%2FLogo.vue&height=50&alt=true&external"
if (typeof block0 === 'function') block0(component)

export default component.exports